import { useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetStudySets = () => {
  const trpc = useTRPC();
  return useSuspenseQuery(
    trpc.studysets.get.queryOptions(
      {},
      { staleTime: Number.POSITIVE_INFINITY },
    ),
  );
};
